module.exports = __webpack_public_path__ + "static/media/f1.662e4fc8.png";